import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      companyAnalysis: {
        ...store.getState().i18n.translations.en.companyAnalysis,
        industryAnalysis: {
          DEFAULT_INDUSTRY: 'Default Industry:',
          COMPARING_INDUSTRY: 'Comparing Industry:',
          SCORE: 'Score',
          CREDIT_RISK_SCORE: 'Corporate Risk Score',
          PERFORMANCE_SCORE: 'Performance Score',
          LAST_UPDATE: 'Last updated date:',
          PERIOD: 'Period:',
          YEARLY: 'Yearly',
          QUARTERLY: 'Quarterly',
          MONTHLY: 'Monthly',
          SHOW_INTERQUARTILE_RANGE: 'Show Interquartile Range',
          LIQUIDITY_SOLVENCY_COVERAGE: 'Liquidity, Solvency and Coverage',
          ASSET_MANAGEMENT_EFFICIENCY: 'Asset Management Efficiency',
          PROFITABILITY: 'Profitability',
          BUSINESS_GROWTH: 'Business Growth',
          CAPITAL_ADEQUACY: 'Capital Adequacy',
          ASSET_QUALITY: 'Asset Quality',
          EARNINGS_QUALITY: 'Earnings Quality',
          LIQUIDITY: 'Liquidity',
          CAPITAL_EARNINGS_LEVERAGE: 'Capital, Earning and Leverage',
          FUNDING_LIQUIDITY: 'Funding & Liquidity',
          UPGRADE_DESC:
            'This feature is currently unavailable for this type of company.',
          UPGRADE_DESC_2:
            'This is advanced features.<br/> Please upgrade your plan to Premium to have better experience.',
          SHOW_ON_CHART: 'Show on chart',
          RATIO: 'Ratio',
          OVER_5_YEARS: 'over 5 years',
          DAYS: 'Days',
          PERCENT: '%',
          TIMES: 'Times',
          BANKING_INDUSTRY: 'Banking Industry',
          SECURITIES_INDUSTRY: 'Securities Industry',
          LIFE_INSURANCE_INDUSTRY: 'Life Insurance Industry',
          NON_LIFE_INSURANCE_INDUSTRY: 'Nonlife Insurance Industry',
          NON_BANK_FIC_INDUSTRY: 'Finance Company Industry',
          NON_BANK_FIO_INDUSTRY: 'Other Financial Institutions Industry',
          NON_BANK_LEA_INDUSTRY: 'Leasing Company Industry',
          INDUSTRY_MEDIAN_RISK_SCORE: 'Industry Median Risk Score',
          NET_REVENUE_GROWTH: 'Net Revenue Growth',
          NET_PROFIT_MARGIN: 'Net Profit Margin',
          ROA: 'ROA',
          TOTAL_DEBT_TO_TOTAL_EQUITY: 'Total Debt to Total Equity',
          CURRENT_RATIO: 'Current Ratio',
          GENERAL_ANALYSIS: 'General Analysis',
          FINANCIAL_RATIOS:
            'Financial Ratios (Data %{currentReportYear} and change vs. %{prevReportYear})',
          ACTIVITIES_RATIOS_RISK: 'Activities ratios & Risk',
          PERFORMANCE_MATRIX: 'Performance Matrix',
          DISTRIBUTION_OF_SCORE: 'Distribution of Score',
          GROUP: 'Group',
          RATIO_1: 'Ratio',
          COMMENTARY: 'Commentary',
          SECTOR_PERFORMANCE_ANALYSIS: 'Sector Performance Analysis',
          COMPARE_BETWEEN: 'Compare between:',
          FDI_DOMESTIC: 'FDI Companies vs Domestic Companies',
          LARGE_SME: 'Large Corporates vs SME Companies',
          LISTED_LARGE: 'Listed Companies vs Large Private Companies',
          SIZE: 'Size (%{year})',
          NUMBER_OF_COMPANIES: 'Number of companies (%{year})',
          RATIO_COMPARISON: 'Ratio Comparison (%{year})',
          TOTAL_ASSETS: 'Total assets',
          TOTAL_REVENUE: 'Total revenue',
          TOTAL_DEBT: 'Total debt',
          FDI: 'FDI Companies',
          DOMESTIC: 'Domestic Companies',
          LARGE: 'Large Companies',
          SME: 'SME Companies',
          LISTED: 'Listed Companies',
          LARGE_PRIVATE: 'Large Private Companies',
          MEDIAN_SCORE: 'Median Score',
          MIN_MAX: 'Min - Max',
          DATE: 'Date: %{date}',
          TITLE: 'Title: %{title}',
          SHORT_CONTENT: 'Short content: %{shortContent}',
          SECTOR: 'Sector:',
          RATIO_2: 'Ratio:',
          COMPANIES: '%{count} Companies',
          COMPANY: '%{count} Company',
          NUMBER_OF_COMPANIES_1: 'Number of companies',
          PERCENT_OF_TOTAL_COMPANIES: '% of total companies',
          INDUSTRY: 'Industry: %{industry}',
          MEDIAN: 'Medium',
          PERCENTILE_VALUE:
            '5th percentile value - 95th percentile range across level 3 VSIC industries',
          FINANCIAL_RATIOS_ACTIVITIES:
            'Financial Ratios, Activities Ratios & Risk',
          SIZE_1: 'Size',
          RATIO_COMPARISON_1: 'Ratio Comparison',
          YEAR: 'Year: %{year}',
          FY: 'FY: %{year}',
          TOTAL_ASSETS_1: 'Total assets (%{currencyUnit})',
          TOTAL_REVENUE_1: 'Total revenue (%{currencyUnit})',
          TOTAL_DEBT_1: 'Total debt (%{currencyUnit})',
          RESET_DEFAULT_INDUSTRY: 'Reset',
          INDUSTRY_1: 'Industry',
          LAST_UPDATED_DATE: 'Last updated date: %{date}',
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      companyAnalysis: {
        ...store.getState().i18n.translations.vi.companyAnalysis,
        industryAnalysis: {
          DEFAULT_INDUSTRY: 'Ngành mặc định:',
          COMPARING_INDUSTRY: 'Ngành so sánh:',
          SCORE: 'Điểm Số',
          CREDIT_RISK_SCORE: 'Điểm rủi ro doanh nghiệp',
          PERFORMANCE_SCORE: 'Điểm tiềm năng tăng trưởng',
          LAST_UPDATE: 'Ngày cập nhật gần nhất:',
          PERIOD: 'Hiển thị theo:',
          YEARLY: 'Theo năm',
          QUARTERLY: 'Theo quý',
          MONTHLY: 'Theo tháng',
          SHOW_INTERQUARTILE_RANGE: 'Hiển thị độ trải giữa',
          LIQUIDITY_SOLVENCY_COVERAGE: 'Khả Năng Thanh Toán',
          ASSET_MANAGEMENT_EFFICIENCY: 'Hiệu Quả Quản Lý Tài Sản',
          PROFITABILITY: 'Tỷ Suất Sinh Lời',
          BUSINESS_GROWTH: 'Tăng Trưởng',
          CAPITAL_ADEQUACY: 'Mức Độ An Toàn Vốn',
          ASSET_QUALITY: 'Chất Lượng Tài Sản',
          EARNINGS_QUALITY: 'Chất Lượng Thu Nhập',
          LIQUIDITY: 'Khả Năng Thanh Toán Nhanh',
          CAPITAL_EARNINGS_LEVERAGE: 'Vốn, Doanh Thu và Đòn Bẩy',
          FUNDING_LIQUIDITY: 'Cơ Cấu Vốn và Khả Năng Thanh Toán Nhanh',
          UPGRADE_DESC:
            'Tính năng này chưa được phát triển cho loại hình doanh nghiệp đang xem.',
          UPGRADE_DESC_2:
            'Đây là tính năng nâng cao. Vui lòng nâng cấp lên Premium để có trải nghiệm tốt hơn.',
          SHOW_ON_CHART: 'Hiển thị trên biểu đồ',
          RATIO: 'Tỷ lệ',
          OVER_5_YEARS: 'trên 5 năm',
          DAYS: 'Ngày',
          PERCENT: '%',
          TIMES: 'Lần',
          BANKING_INDUSTRY: 'Ngành Ngân Hàng',
          SECURITIES_INDUSTRY: 'Ngành Chứng Khoán',
          LIFE_INSURANCE_INDUSTRY: 'Ngành Bảo Hiểm Nhân Thọ',
          NON_LIFE_INSURANCE_INDUSTRY: 'Ngành Bảo Hiểm Phi Nhân Thọ',
          NON_BANK_FIC_INDUSTRY: 'Ngành Công Ty Tài Chính',
          NON_BANK_FIO_INDUSTRY: 'Ngành Công Ty Tài Chính Phi Ngân Hàng',
          NON_BANK_LEA_INDUSTRY: 'Ngành Công Ty Cho Thuê Tài Chính',
          INDUSTRY_MEDIAN_RISK_SCORE: 'Điểm rủi ro trung vị ngành',
          NET_REVENUE_GROWTH: 'Tăng trưởng doanh thu thuần',
          NET_PROFIT_MARGIN: 'Biên lợi nhuận ròng',
          ROA: 'ROA',
          TOTAL_DEBT_TO_TOTAL_EQUITY: 'Tổng nợ vay / VCSH',
          CURRENT_RATIO: 'Tỷ số thanh khoản hiện thời',
          GENERAL_ANALYSIS: 'Phân tích tổng quan',
          FINANCIAL_RATIOS:
            'Chỉ số tài chính (Số liệu %{currentReportYear} và chênh lệch so với %{prevReportYear})',
          ACTIVITIES_RATIOS_RISK: 'Chỉ số hoạt động và rủi ro',
          PERFORMANCE_MATRIX: 'Biểu đồ so sánh đa tiêu chí',
          DISTRIBUTION_OF_SCORE: 'Phân phối điểm số',
          GROUP: 'Nhóm chỉ số',
          RATIO_1: 'Chỉ số',
          COMMENTARY: 'Nhận xét',
          SECTOR_PERFORMANCE_ANALYSIS: 'Phân tích theo phân khúc trong ngành',
          COMPARE_BETWEEN: 'So sánh theo:',
          FDI_DOMESTIC: 'Doanh nghiệp FDI so với doanh nghiệp trong nước',
          LARGE_SME: 'Tập đoàn lớn so với doanh nghiệp vừa và nhỏ (SME)',
          LISTED_LARGE: 'Công ty niêm yết so với công ty tư nhân lớn',
          SIZE: 'Quy mô ngành (%{year})',
          NUMBER_OF_COMPANIES: 'Số lượng công ty (%{year})',
          RATIO_COMPARISON: 'Tương quan chỉ số (%{year})',
          TOTAL_ASSETS: 'Tổng tài sản',
          TOTAL_REVENUE: 'Tổng doanh thu',
          TOTAL_DEBT: 'Tổng nợ',
          FDI: 'Doanh nghiệp FDI',
          DOMESTIC: 'Doanh nghiệp trong nước',
          LARGE: 'Tập đoàn lớn',
          SME: 'Doanh nghiệp vừa và nhỏ',
          LISTED: 'Công ty niêm yết',
          LARGE_PRIVATE: 'Công ty tư nhân lớn',
          MEDIAN_SCORE: 'Điểm trung vị',
          MIN_MAX: 'Giá trị nhỏ nhất - Lớn nhất',
          DATE: 'Ngày: %{date}',
          TITLE: 'Tiêu đề: %{title}',
          SHORT_CONTENT: 'Nội dung: %{shortContent}',
          SECTOR: 'Phân khúc ngành:',
          RATIO_2: 'Chỉ số:',
          COMPANIES: '%{count} Công ty',
          COMPANY: '%{count} Công ty',
          NUMBER_OF_COMPANIES_1: 'Số lượng công ty',
          PERCENT_OF_TOTAL_COMPANIES: 'Tỷ trọng',
          INDUSTRY: 'Ngành: %{industry}',
          MEDIAN: 'Trung vị',
          PERCENTILE_VALUE:
            'Giá trị phân vị 5% - Giá trị phân vị 95% trong tập các ngành VSIC cấp 3',
          FINANCIAL_RATIOS_ACTIVITIES:
            'Chỉ số tài chính, Chỉ số hoạt động và rủi ro',
          SIZE_1: 'Quy mô ngành',
          RATIO_COMPARISON_1: 'Tương quan chỉ số',
          YEAR: 'Năm: %{year}',
          FY: 'Năm tài chính: %{year}',
          TOTAL_ASSETS_1: 'Tổng tài sản (%{currencyUnit})',
          TOTAL_REVENUE_1: 'Tổng doanh thu (%{currencyUnit})',
          TOTAL_DEBT_1: 'Tổng nợ (%{currencyUnit})',
          RESET_DEFAULT_INDUSTRY: 'Đặt lại',
          INDUSTRY_1: 'Ngành',
          LAST_UPDATED_DATE: 'Ngày cập nhật gần nhất: %{date}',
        },
      },
    },
  }),
)
